import Spinner from 'app/components/Spinner';
import { setUserInfo } from 'app/utils';
import { refreshToken } from 'app/utils/refreshToken';
import { setSessionLogger } from 'app/utils/sessionLogger';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import PrivateLayoutBackdrop from '../PrivateLayoutBackdrop';

const PrivateLayout = () => {
  const accessToken = useSelector(({ user }) => user.accessToken);
  const { featureFlagsLoading } = useSelector(({ common }) => common);
  const [tokenChecked, setTokenChecked] = useState(!!accessToken);

  useEffect(() => {
    if (!accessToken) {
      refreshToken()
        .then(() => {
          setUserInfo();
          setSessionLogger();
          setTokenChecked(true);
        })
        .catch(() => {
          setTokenChecked(true);
        });
    }
  }, []);

  if (!tokenChecked) {
    return <Spinner />;
  }
  if (!accessToken) {
    return <Navigate to='/login' replace />;
  }
  return (
    <>
      {featureFlagsLoading ? <Spinner /> : <Outlet />}
      <PrivateLayoutBackdrop />
    </>
  );
};

export default PrivateLayout;
